export default "__VITE_ASSET__BZGMFYcg__"